"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var SliderControls = /*#__PURE__*/function () {
  function SliderControls(component) {
    var _this = this;

    _classCallCheck(this, SliderControls);

    this.component = void 0;

    this.goToSlide = function (_ref) {
      var _this$component$props, _this$component$props2;

      var slideIndex = _ref.slideIndex,
          trigger = _ref.trigger;
      if (_this.component.state.transitioning || !_this.component.sliderRef) return;

      if ((_this$component$props = _this.component.props.pager) !== null && _this$component$props !== void 0 && _this$component$props.onClick && trigger === 'pager') {
        _this.component.props.pager.onClick(_this.getAnalyticsPayload(trigger, slideIndex));
      }

      if ((_this$component$props2 = _this.component.props.arrows) !== null && _this$component$props2 !== void 0 && _this$component$props2.onClick && (trigger === 'nextArrow' || trigger === 'previousArrow')) {
        _this.component.props.arrows.onClick(_this.getAnalyticsPayload(trigger, slideIndex));
      }

      _this.component.sliderRef.slickGoTo(slideIndex, false);
    };

    this.goToPagerNumber = function (pagerNumber) {
      var slideToGoTo = _this.component.state.slidesToScroll * pagerNumber;

      _this.goToSlide({
        slideIndex: slideToGoTo,
        trigger: 'pager'
      });
    };

    this.goToNextSlide = function () {
      _this.goToSlide({
        slideIndex: _this.component.state.currentSlide + _this.component.state.slidesToScroll,
        trigger: 'nextArrow'
      });
    };

    this.goToPreviousSlide = function () {
      _this.goToSlide({
        slideIndex: _this.component.state.currentSlide - _this.component.state.slidesToScroll,
        trigger: 'previousArrow'
      });
    };

    this.play = function () {
      if (!_this.component.sliderRef) return;

      _this.component.sliderRef.slickPlay();

      _this.component.setState({
        playing: true
      });
    };

    this.pause = function () {
      if (!_this.component.sliderRef) return;

      _this.component.sliderRef.slickPause();

      _this.component.setState({
        playing: false
      });
    };

    this.component = component;
  }

  _createClass(SliderControls, [{
    key: "slides",
    get: function get() {
      if (this.component.sliderRef && Array.isArray(this.component.sliderRef.props.children)) {
        return this.component.sliderRef.props.children;
      }

      return [];
    }
  }, {
    key: "getAnalyticsPayload",
    value: function getAnalyticsPayload(trigger, slideIndex) {
      return {
        currentSlide: slideIndex,
        id: this.component.props.id,
        numberOfSlides: this.slides.length,
        trigger: trigger
      };
    }
  }]);

  return SliderControls;
}();

exports["default"] = SliderControls;
//# sourceMappingURL=SliderControls.js.map